module.exports = __webpack_public_path__ + "img/about_main.9ca31b02.jpg";